export const STATUS_ENTWURF = 'Entwurf';
export const STATUS_OFFEN = 'Offen';
export const STATUS_IN_ARBEIT = 'In Arbeit';
export const STATUS_ERLEDIGT = 'Erledigt';
export const STATUS_HINFAELLIG = 'Hinfällig';
export const STATUS_GELOESCHT = 'Gelöscht';
